import { useEffect, useState } from "react";
import axios from "axios";
import { POSTS } from "@/content/blog";

const API = process.env.REACT_APP_BACKEND_URL;

export const shareImageUrl = (post) => {
  const ba = (post?.sections || []).find((s) => s.before) || post;
  if (!API || !ba?.before) return null;
  const q = new URLSearchParams({ title: post.title, before: ba.before, after: ba.after });
  return `${API}/api/share-image?${q.toString()}`;
};

export const useAllPosts = () => {
  const [extra, setExtra] = useState([]);
  useEffect(() => {
    if (!API) return undefined;
    axios.get(`${API}/api/posts`).then((r) => setExtra(Array.isArray(r.data?.posts) ? r.data.posts : [])).catch(() => setExtra([]));
    return undefined;
  }, []);
  const slugs = new Set(extra.map((p) => p.slug));
  return [...extra, ...POSTS.filter((p) => !slugs.has(p.slug))].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));
};

export const usePost = (slug) => {
  const local = POSTS.find((p) => p.slug === slug);
  const [state, setState] = useState(local ? { post: local } : { loading: true });
  useEffect(() => {
    if (local) { setState({ post: local }); return undefined; }
    if (!API) { setState({ missing: true }); return undefined; }
    setState({ loading: true });
    axios.get(`${API}/api/posts/${slug}`).then((r) => setState(r.data?.slug ? { post: r.data } : { missing: true })).catch(() => setState({ missing: true }));
    return undefined;
  }, [slug, local]);
  return state;
};
